import { createStore } from 'vuex';
import VuexPersistence from 'vuex-persist';
import Cookies from 'js-cookie';
import user from './modules/user';
import home from './modules/home';
import hotels from './modules/hotels';
import profile from './modules/profile';
import details from './modules/details';
import hotelDetails from './modules/hotelDetails';
import detailsFilter from './modules/detailsFilter';
import filter from './modules/filter';
import itinerary from './modules/itinerary';
import destination from './modules/destination';
import facilities from './modules/facilities';
import cookies from './modules/cookies';
import notifications from './modules/notifications';
import hotelBrands from './modules/hotelBrands';
import branding from './modules/branding';

const vuexCookie = new VuexPersistence({
  // js-cookie 3: getJSON removed and objects are no longer auto-serialized
  restoreState: key => {
    const value = Cookies.get(key);
    if (value === undefined) {
      return undefined;
    }
    try {
      const restored = JSON.parse(value);
      // vuex-persist merges this straight over the module state. A cookie left
      // by an older build on the same origin can hold a null or a bare string
      // where the user module belongs; that wipes the module, every getter on
      // it collapses, and the app renders an empty shell with no console error
      // — indistinguishable from a broken deploy. Restore only our own shape.
      const isPlainObject = v =>
        v !== null && typeof v === 'object' && !Array.isArray(v);
      if (!isPlainObject(restored) || !isPlainObject(restored.user)) {
        return undefined;
      }
      return restored;
    } catch (e) {
      return undefined;
    }
  },
  saveState: (key, state) => {
    return Cookies.set(key, JSON.stringify(state), {
      expires: 3
    });
  },
  modules: ['user']
});
export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    profile,
    home,
    hotels,
    details,
    hotelDetails,
    detailsFilter,
    filter,
    itinerary,
    destination,
    facilities,
    cookies,
    notifications,
    hotelBrands,
    branding
  },
  plugins: [vuexCookie.plugin]
});
